import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { Icons, Tooltip } from '@/js/libs/ui/src/V2';

import { useServiceStatus } from 'src/hooks/useServiceStatus.ts';
import { STATUS_ICON_SIZE_VALUE, StatusLink } from './styled.ts';

type StatusButtonProps = {
  isCollapsedNav: boolean;
};

export const StatusButton = memo(function StatusButton({ isCollapsedNav }: StatusButtonProps) {
  const [t] = useTranslation(['common']);
  const { colors } = useTheme();
  const { hasSystemIssues } = useServiceStatus();

  const statusText = hasSystemIssues ? t('common:NOT_ALL_SYSTEMS_OPERATIONAL') : t('common:ALL_SYSTEMS_OPERATIONAL');

  return (
    <Tooltip tooltip={statusText} placement='top-start'>
      <StatusLink href='https://status.audienzz.com/' target='_blank' rel='noopener noreferrer' $isCollapsedNav={isCollapsedNav}>
        {hasSystemIssues ? (
          <Icons.Clear color={colors.critical100} filled size={STATUS_ICON_SIZE_VALUE} />
        ) : (
          <Icons.Check color={colors.positive100} filled size={STATUS_ICON_SIZE_VALUE} />
        )}
      </StatusLink>
    </Tooltip>
  );
});
